// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4y-6";
export var headerCell = "_4y-2";
export var rowWrapper = "_4y-4";
export var stickyAggregationCell = "_4y-a";
export var stickyAggregationRow = "_4y-7";
export var stickyColumnCell = "_4y-9";
export var stickyColumnHeaderCell = "_4y-8";
export var table = "_4y-1";
export var virtualRowWrapper = "_4y-5";
export var virtualTableContainer = "_4y-0";
export var white = "_4y-3";